"use strict";
const defaultMenuItem_1 = require("../../@inax/menu/src/default/defaultMenuItem");
const defaultMenuProvider_1 = require("../../@inax/menu/src/default/defaultMenuProvider");
let menu = [
    new defaultMenuItem_1.DefaultMenuItem(0, "Main", "", [
        new defaultMenuItem_1.DefaultMenuItem(0, "Home", "/home")
    ]),
    new defaultMenuItem_1.DefaultMenuItem(1, "Controller", "", []),
    new defaultMenuItem_1.DefaultMenuItem(2),
    new defaultMenuItem_1.DefaultMenuItem(3, "Motions", "", [
        new defaultMenuItem_1.DefaultMenuItem(0, "VK", "/motion/1100"),
        new defaultMenuItem_1.DefaultMenuItem(1, "Station", "/motion/1180")
    ]),
    new defaultMenuItem_1.DefaultMenuItem(4, "Alarms", "", [
        new defaultMenuItem_1.DefaultMenuItem(0, "Pending", "/alarms/pending"),
        new defaultMenuItem_1.DefaultMenuItem(4, "History", "/alarms/historical")
    ]),
    new defaultMenuItem_1.DefaultMenuItem(5, "Diagnosis", "", [
        new defaultMenuItem_1.DefaultMenuItem(12, "Sql", "/sqlviewer")
    ]),
    new defaultMenuItem_1.DefaultMenuItem(6),
    new defaultMenuItem_1.DefaultMenuItem(7, "Maintenance", "", [
        new defaultMenuItem_1.DefaultMenuItem(1, "Login", "/login"),
        new defaultMenuItem_1.DefaultMenuItem(2, "INAXConfig", "/configuration"),
        new defaultMenuItem_1.DefaultMenuItem(3, "Test", "/testpage"),
        new defaultMenuItem_1.DefaultMenuItem(4, "Plc", "/plcviewer"),
        new defaultMenuItem_1.DefaultMenuItem(5, "Sql", "/sqlviewer"),
        new defaultMenuItem_1.DefaultMenuItem(7, "Script", "/scriptviewer")
    ]),
];
exports.APP_MENU = {
    provide: defaultMenuProvider_1.BUTTONMENU_TOKEN,
    useValue: menu
};
